<div class="row g-3 align-items-end">
  <div class="col-md-4">
    <label class="form-label">Empregador</label>
    <select class="form-select" [ngModel]="empregadorSelecionado" (ngModelChange)="selecionarEmpregador($event)">
      <option value="">Selecione</option>
      <option *ngFor="let empregador of empregadores" [value]="empregador.id">{{ empregador.razaoSocial }}</option>
    </select>
  </div>

  <div class="col-md-4">
    <label class="form-label">Departamento</label>
    <app-seletor-multiplo-departamentos
      [departamentos]="departamentos"
      [idsSelecionados]="departamentoSelecionado"
      (idsSelecionadosChange)="departamentoSelecionadoChange.emit($event)">
    </app-seletor-multiplo-departamentos>
  </div>

  <div class="col-md-4">
    <label class="form-label">Funcionario</label>
    <app-busca-pesquisavel
      [termo]="buscaFuncionario"
      nomeCampo="buscaFuncionarioPendencia"
      placeholder="Todos os funcionarios"
      [itens]="funcionariosFiltrados"
      [rotuloItem]="rotuloFuncionario"
      [detalheItem]="detalheFuncionario"
      (termoChange)="buscaFuncionarioChange.emit($event)"
      (digitou)="digitouFuncionario.emit($event)"
      (buscar)="abrirModalFuncionario.emit()"
      (selecionar)="selecionarFuncionario.emit($event)">
    </app-busca-pesquisavel>
  </div>

  <div class="col-md-2">
    <label class="form-label">Data inicial</label>
    <input class="form-control" type="date" [ngModel]="dataInicial" (ngModelChange)="dataInicialChange.emit($event)">
  </div>

  <div class="col-md-2">
    <label class="form-label">Data final</label>
    <input class="form-control" type="date" [ngModel]="dataFinal" (ngModelChange)="dataFinalChange.emit($event)">
  </div>

  <div class="col-12 d-flex gap-2">
    <button type="button" class="btn btn-primary px-4" (click)="pesquisar.emit()">
      <i class="bi bi-search px-2"></i>Pesquisar
    </button>
    <button type="button" class="btn btn-warning px-4" (click)="limpar.emit()">
      <i class="bi bi-x-lg px-2"></i>Limpar
    </button>
    <button type="button" class="btn btn-secondary px-4" (click)="imprimir.emit()">
      <i class="bi bi-printer px-2"></i>Imprimir
    </button>
  </div>
</div>
